import { render } from "./cart_manual.vue?vue&type=template&id=0938af7c&scoped=true"
import script from "./cart_manual.vue?vue&type=script&lang=js"
export * from "./cart_manual.vue?vue&type=script&lang=js"

import "./cart_manual.vue?vue&type=style&index=0&id=0938af7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0938af7c"]])

export default __exports__